import { Close } from "@mui/icons-material";
import { Box, CardHeader, Avatar, Button, Card, IconButton, CardContent, CardActions } from "@mui/material";
import { useRef, useState } from "react";
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import bannerSrc from "@arelia-assets/banner1.jpg";
import AvatarConfirmationDialog from "./AvatarConfirmationDialog";

interface Props {
  handleAvatarChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleAvatarDelete: () => void;
  handleCoverChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  avatarUrl: string;
  coverUrl: string;
  avatarIsLoading: boolean;
  coverIsLoading: boolean;
}

export default function AvatarPresenter({
  handleAvatarChange,
  handleCoverChange,
  handleAvatarDelete,
  avatarUrl,
  coverUrl,
  avatarIsLoading,
  coverIsLoading
}: Props) {
  const avatarInputRef = useRef(HTMLInputElement.prototype);
  const coverInputRef = useRef(HTMLInputElement.prototype);
  const [confirmationAvatarOpened, setConfirmationAvatarOpened] = useState(false);

  const handleEditAvatar = () => {
    avatarInputRef.current.click();
  };
  const handleEditCover = () => {
    coverInputRef.current.click();
  };

  const handleAvatarDialogClose = (isConfirmed: boolean) => {
    if (isConfirmed) {
      handleAvatarDelete();
    }
    setConfirmationAvatarOpened(false);
  };

  const openAvatarDeletionDialog = () => {
    setConfirmationAvatarOpened(true);
  };

  return (
    <Card sx={{
      gridColumn: "span 4",
      gridRow: "span 8"
    }}>
      <CardHeader title="Avatar" />
      <CardContent>
        <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" pt={5} pb={2}>
          <Box sx={{
            width: 100,
            height: 100,
            position: "relative",
          }}>
            <SpinnerWrapper loading={avatarIsLoading}>
              <Avatar
                src={avatarUrl}
                sx={{
                  width: 100,
                  height: 100,
                }}
              />
              {
                avatarUrl
                  ? <IconButton
                    sx={{ position: "absolute", right: "-20px", top: "-10px" }}
                    onClick={openAvatarDeletionDialog}
                    color="error"
                  >
                    <Close />
                  </IconButton>
                  : <></>
              }
            </SpinnerWrapper>
          </Box>
          <Box sx={{
            width: "100%",
            height: 100,
            marginTop: "8px",
            position: "relative",
          }}>
            <SpinnerWrapper loading={coverIsLoading}>
              <div style={{ width: "100%", height: "100%", backgroundImage: `url(${coverUrl || bannerSrc})`, backgroundSize: "cover", backgroundPosition: "center" }}></div>
            </SpinnerWrapper>
          </Box>
        </Box>
      </CardContent>
      <CardActions sx={{ justifyContent: "center" }}>
        <Button
          onClick={handleEditAvatar}
          variant="contained"
          size="large"
        >
          Select Avatar
        </Button>
        <input
          type="file"
          style={{ display: 'none' }}
          ref={avatarInputRef}
          onChange={handleAvatarChange}
        />

        <Button
          onClick={handleEditCover}
          variant="outlined"
          size="large"
        >
          Select Cover
        </Button>
        <input
          type="file"
          style={{ display: 'none' }}
          ref={coverInputRef}
          onChange={handleCoverChange}
        />
      </CardActions>

      <AvatarConfirmationDialog
        open={confirmationAvatarOpened}
        onClose={handleAvatarDialogClose}
      />
    </Card>
  );
}
